<template>
  <div class="animated fadeIn">
    <div>
      <StyledDialogReviewOrder
        :seminar_object="seminar.seminar_edit"
        :EntityType="StatusTypeString"
        :StatusType="StatusType"
      >
        <div slot="header"></div>
        <div slot="details"></div>
        <span slot="entityType">{{ StatusTypeString }}</span>
      </StyledDialogReviewOrder>
    </div>

    <div>
      <StyledDialogConfirmOrder
        :seminar_object="seminar.seminar_edit"
        EntityType="Confirm Order"
      >
        <div slot="header"></div>
        <div slot="details"></div>
        <span slot="entityType">Confirm Order</span>
      </StyledDialogConfirmOrder>
    </div>
    <div>
      <ConflictsModal/>
    </div>
    <b-row>
      <b-col lg="12">
        <b-form @submit.prevent="save">
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <CoolSelect
                  v-model="seminar.seminar_edit.TerritoryID"
                  placeholder="Select Territory"
                  theme="bootstrap"
                  tooltip="Territory"
                  :items="territory.territories"
                  item-text="TerritoryName"
                  item-value="TerritoryID"
                  id="TerritoryID"
                  @select="setTerritoryName"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth_Less"
                        >Territory</b-input-group-text
                      >
                    </b-input-group-prepend>
                  </template>
                </CoolSelect>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <CoolSelect
                  v-model="seminar.seminar_edit.EventTypeID"
                  placeholder="Type"
                  theme="bootstrap"
                  tooltip="Event Type"
                  :items="seminar.event_types"
                  item-text="EventTypeName"
                  item-value="EventTypeID"
                  id="EventTypeID"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth_Less"
                        >Event Type</b-input-group-text
                      >
                    </b-input-group-prepend>
                  </template>
                </CoolSelect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <CoolSelect
                  v-model="seminar.seminar_edit.UserProfileID"
                  placeholder="Account Manager"
                  theme="bootstrap"
                  tooltip="Account Manager"
                  :items="n_user.n_users"
                  item-text="UserName"
                  item-value="UserProfileID"
                  id="UserProfileID"
                  @select="setOwnerName"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth_Less"
                        >Assigned To</b-input-group-text
                      >
                    </b-input-group-prepend>
                  </template>
                </CoolSelect>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <CoolSelect
                  v-model="seminar.seminar_edit.VendorID"
                  placeholder="Vendor"
                  theme="bootstrap"
                  tooltip="Vendor"
                  :items="seminar.vendors"
                  item-text="Name"
                  item-value="VendorID"
                  id="VendorID"
                  @select="setVendorName"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth_Less"
                        >Vendor</b-input-group-text
                      >
                    </b-input-group-prepend>
                  </template>
                </CoolSelect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" />
            <b-col md="3">
              <b-form-checkbox
                v-if="false"
                class="ml-1 mt-2"
                id="ContractReceived"
                v-model="seminar.seminar_edit.ContractReceived"
                name="ContractReceived"
                :value="true"
                :unchecked-value="false"
                >Contract Received</b-form-checkbox
              >
              <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-envelope appendIcon"></i>
                    </b-input-group-text>
              </b-input-group-append>-->
            </b-col>
            <b-col md="3" v-if="seminar.seminar_edit.ContractReceived">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth_Less"
                      >Received on</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <datepicker
                    @dp-change="addDirtyField"
                    :value="seminar.seminar_edit.DateContractReceived"
                    :config="options"
                    id="ContractReceivedDate"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6 mb-3">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth_Less"
                      >Clusters</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.seminar_edit.ClusterDescription"
                    placeholder="Cluster Description (optional)"
                    type="text"
                    autocomplete="off"
                    id="ClusterDescription"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6 mb-3">
              <!-- <b-form-radio-group
                class="mr-3"
                id="radiosBtn"
                buttons
                button-variant="outline-primary"
                v-model="seminar.seminar_edit.IsSplit"
                name="radiosBtn"
              >
                <b-form-radio class="mx-0" :value="false"
                  >Use single mail piece (default)</b-form-radio
                >
                <b-form-radio class="mx-0" :value="true"
                  >Split between 2 mail pieces</b-form-radio
                >
              </b-form-radio-group> -->
              <c-switch
                width="100px"
                class="mx-3 pt-2"
                color="primary"
                variant="pill"
                id="IsSplit"
                v-model="seminar.seminar_edit.IsSplit"
              />
              <span
                v-if="seminar.seminar_edit.IsSplit"
                class="text-success bold"
                >Mailer Test (ON)</span
              >
              <span
                v-if="!seminar.seminar_edit.IsSplit"
                class="text-danger bold"
                >Mailer Test (OFF)</span
              >
            </b-col>

            <!-- <b-col md="3">
              <b-form-checkbox
                class="ml-1 mt-2"
                id="ContractReceived"
                v-model="seminar.seminar_edit.ContractReceived"
                name="ContractReceived"
                :value="true"
                :unchecked-value="false"
              >Contract Received</b-form-checkbox>
            </b-col>
            <b-col md="3" v-if="seminar.seminar_edit.ContractReceived">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth_Less">Received on</b-input-group-text>
                  </b-input-group-prepend>
                  <datepicker
                    @dp-change="addDirtyField"
                    :value="seminar.seminar_edit.DateContractReceived"
                    :config="options"
                    id="ContractReceivedDate"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>-->
          </b-row>

          <b-row>
            <b-col sm="6">
              <b-form-group>
                <CoolSelect
                  v-model="seminar.seminar_edit.Artwork1ID"
                  placeholder="Artwork Type"
                  theme="bootstrap"
                  tooltip="Artwork Type"
                  :items="seminar.artwork_types"
                  item-text="ArtworkName"
                  item-value="ArtworkID"
                  id="Artwork1ID"
                  @select="setArtwork1Name"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth_Less"
                        >Mailer 1</b-input-group-text
                      >
                    </b-input-group-prepend>
                  </template>
                </CoolSelect>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth_Less"
                      >Quantity</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.seminar_edit.Quantity1"
                    placeholder="Quantity"
                    type="text"
                    autocomplete="off"
                    id="Quantity1"
                    v-mask="'######'"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth_Less"
                      >Cost</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.seminar_edit.Cost1"
                    placeholder="Cost"
                    type="text"
                    autocomplete="off"
                    id="Cost1"
                    @change.native="addDirtyField"
                    numeric
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="seminar.seminar_edit.IsSplit">
            <b-col sm="6">
              <b-form-group>
                <CoolSelect
                  v-model="seminar.seminar_edit.Artwork2ID"
                  placeholder="Artwork Type"
                  theme="bootstrap"
                  tooltip="Artwork Type"
                  :items="seminar.artwork_types"
                  item-text="ArtworkName"
                  item-value="ArtworkID"
                  id="Artwork2ID"
                  @select="setArtwork2Name"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth_Less"
                        >Mailer 2</b-input-group-text
                      >
                    </b-input-group-prepend>
                  </template>
                </CoolSelect>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth_Less"
                      >Quantity</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.seminar_edit.Quantity2"
                    placeholder="Quantity"
                    type="text"
                    autocomplete="off"
                    id="Quantity2"
                    v-mask="'######'"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth_Less"
                      >Cost</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.seminar_edit.Cost2"
                    placeholder="Cost"
                    type="text"
                    autocomplete="off"
                    id="Cost2"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row style="height: 20px">
            <b-col />
          </b-row>
          <b-row>
            <b-col md="12">
              <div class="form-group form-actions" style="float: left">
                <b-button
                  class="mr-2 mt-2"
                  size="md"
                  variant="outline-primary"
                  @click="[requestCounts(), save()]"
                >
                  <!-- <i class="fa fa-close"></i> -->
                  Request Counts
                </b-button>
                <b-button
                  class="mr-2 mt-2 standardizedWidth"
                  size="md"
                  variant="outline-primary"
                  @click="[confirmCounts(), save()]"
                >
                  <!-- <i class="fa fa-close"></i> -->
                  Review Order
                </b-button>
                <b-button
                  class="mr-2 mt-2 standardizedWidth"
                  size="md"
                  variant="outline-success"
                  @click="[submitOrder(), save()]"
                >
                  <!-- <i class="fa fa-close"></i> -->
                  Place Order
                </b-button>
              </div>
              <div class="form-group form-actions" style="float: right">
                <b-button
                  class="mr-2 mt-2 standardizedWidth"
                  size="md"
                  variant="outline-primary"
                  @click="back"
                >
                  <!-- <i class="fa fa-close"></i> -->
                  Close
                </b-button>
                <b-button
                  class="mr-0 mt-2"
                  type="submit"
                  size="md"
                  variant="primary"
                  :disabled="isClean"
                >
                  <i class="fa fa-save"></i>
                  Save
                </b-button>
              </div>
              <div class="form-group form-actions" style="float: right">
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismissCountDown"
                  fade
                  variant="light"
                  :dismissed="(dismissCountdown = 0)"
                  @dismiss-count-down="countDownChanged"
                >
                  Your information has been saved
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismiss2CountDown"
                  fade
                  variant="danger"
                  :dismissed="(dismiss2Countdown = 0)"
                  @dismiss-count-down="countDown2Changed"
                >
                  Your information could not be saved. Check all fields
                  carefully.
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
              </div>
            </b-col>
          </b-row>
          <b-row style="height: 20px">
            <b-col />
          </b-row>
          <b-row class="primary2-row divider-row">
            <b-col md="9" class="text-left">
              <span class="icon-small">
                <i
                  v-if="!seating_seen"
                  class="fa fa-plus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="toggleSeatings"
                ></i>
                <i
                  v-if="seating_seen"
                  class="fa fa-minus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="toggleSeatings"
                ></i>
                <h4 class="display-4 drtext">Seminar Dates</h4>
              </span>
            </b-col>
            <b-col md="3" style="float: right">
              <div class="form-group form-actions" style="float: right">
                <b-button
                  v-if="seminar.seminar_edit.SeminarID === -1 && seating_seen"
                  class="mr-2 mt-2"
                  size="md"
                  variant="primary"
                  @click="save"
                  style="
                    background-color: rgba(32, 216, 93, 0.85);
                    border-color: rgba(32, 216, 93, 0.95);
                  "
                >
                  <!-- <i class="fa fa-close"></i> -->
                  Add Seminar Date
                </b-button>
                <b-button
                  v-if="seminar.seminar_edit.SeminarID > -1 && seating_seen"
                  class="mr-2 mt-2"
                  size="md"
                  variant="primary"
                  @click="addSeating"
                  style="
                    background-color: rgba(32, 216, 93, 0.85);
                    border-color: rgba(32, 216, 93, 0.95);
                  "
                >
                  <!-- <i class="fa fa-close"></i> -->
                  Add Seminar Date
                </b-button>
              </div>
            </b-col>
          </b-row>
          <SeatingRow
            v-show="seating_seen"
            v-for="seating in seminar.seminar_edit.Seatings"
            :key="seating.SeatingID"
            :seating_object="seating"
            :seminar_object="seminar.seminar_edit"
            @RemoveSeating="removeSeating"
            @ChangeSeatingDate="changeSeatingDate"
          />

          <b-row style="height: 20px">
            <b-col />
          </b-row>
          <b-row class="primary3-row divider-row">
            <b-col md="9" class="text-left">
              <span class="icon-small">
                <i
                  v-if="!filters_seen"
                  class="fa fa-plus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="toggleFilters"
                ></i>
                <i
                  v-if="filters_seen"
                  class="fa fa-minus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="toggleFilters"
                ></i>
                <h4 class="display-4 drtext">Filters</h4>
              </span>
            </b-col>

            <b-col md="3" style="float: right">
              <div class="form-group form-actions" style="float: right">
                <b-button
                  v-if="seminar.seminar_edit.SeminarID > -1 && filters_seen"
                  class="mr-2 mt-2"
                  size="md"
                  variant="primary"
                  @click="addFilter"
                  style="
                    background-color: rgba(216, 142, 32, 0.85);
                    border-color: rgba(216, 142, 32, 0.95);
                  "
                >
                  <!-- <i class="fa fa-close"></i> -->
                  Add Filter Group
                </b-button>
              </div>
            </b-col>
          </b-row>
          <FilterRow
            v-show="filters_seen"
            v-for="filter in seminar.seminar_edit.Filters"
            :key="filter.FilterID"
            :filter_object="filter"
            :seminar_object="seminar.seminar_edit"
            @RemoveFilter="removeFilter"
          />
          <b-row style="height: 20px">
            <b-col />
          </b-row>
          <b-row class="primary4-row divider-row">
            <b-col md="9" class="text-left">
              <span class="icon-small">
                <i
                  v-if="!zip_seen"
                  class="fa fa-plus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="toggleZips"
                ></i>
                <i
                  v-if="zip_seen"
                  class="fa fa-minus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="toggleZips"
                ></i>
                <h4 class="display-4 drtext">Zip Codes</h4>
              </span>
            </b-col>
            <b-col md="3" style="float: right">
              <div class="form-group form-actions" style="float: right">
                <!-- <b-button
                  v-if="seminar.seminar_edit.SeminarID > -1"
                  class="mr-2 mt-2"
                  size="md"
                  variant="primary"
                  @click="toggleZips"
                  style="background-color: rgba(158, 32, 216, 0.85); border-color: rgba(158, 32, 216, 0.95); width: 134px;"
                >{{zipButtonText}}</b-button>-->
              </div>
            </b-col>
          </b-row>
          <ZipEditor
            @CurrentZipCollectionChange="refreshZips"
            :seminar_object="seminar.seminar_edit"
            v-if="zip_seen"
          />
          <b-row style="height: 20px">
            <b-col />
          </b-row>
          <b-row class="primary-row divider-row">
            <b-col md="9" class="text-left">
              <span class="icon-small">
                <i
                  v-if="!aux_seen"
                  class="fa fa-plus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="toggleAux"
                ></i>
                <i
                  v-if="aux_seen"
                  class="fa fa-minus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="toggleAux"
                ></i>
                <h4 class="display-4 drtext">Auxiliaries</h4>
              </span>
            </b-col>
            <b-col md="3" style="float: right">
              <div class="form-group form-actions" style="float: right"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-tabs v-if="seminar.seminar_edit.SeminarID > -1 && aux_seen">
                <b-tab active>
                  <template slot="title">
                    <i class="fa fa-calculator fa-lg"></i>
                    <span style="display: inline-block" class="ml-1 tabtext"
                      >Statistics</span
                    >
                  </template>
                  <!-- <b-list-group></b-list-group> -->
                  <StatisticsContainer :seminar_object="seminar.seminar_edit" />
                </b-tab>
                <b-tab>
                  <template slot="title">
                    <i class="fa fa-calendar fa-lg"></i>
                    <span style="display: inline-block" class="ml-1 tabtext"
                      >Additional Info</span
                    >
                  </template>
                 <b-form-textarea
                    v-model.lazy="seminar.seminar_edit.SpecialInstructions"
                    type="text"
                    autocomplete="off"
                    id="SpecialInstructions"
                    @change.native="addDirtyField"

                  ></b-form-textarea>
                </b-tab>
                <b-tab>
                  <template slot="title">
                    <i class="fa fa-calendar fa-lg"></i>
                    <span style="display: inline-block" class="ml-1 tabtext"
                      >Tracking</span
                    >
                  </template>
                  <SeminarTracker
                    v-if="seminar.seminar_edit.Tracker.TrackingID"
                    :seminar_object="seminar.seminar_edit"
                  />
                </b-tab>
                <b-tab>
                  <template slot="title">
                    <i class="fa fa-map-marker fa-lg"></i>
                    <span style="display: inline-block" class="ml-1 tabtext"
                      >Enter Counts</span
                    >
                  </template>
                  <CurrentZipEditor :seminar_object="seminar.seminar_edit" />
                </b-tab>
                <b-tab>
                  <template slot="title">
                    <i class="fa fa-dollar fa-lg"></i>
                    <span style="display: inline-block" class="ml-1 tabtext"
                      >Appointments</span
                    >
                  </template>
                  <AppointmentContainer
                    :seminar_object="seminar.seminar_edit"
                  />
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
          <b-row style="height: 50px">
            <b-col />
          </b-row>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import { required, email, helpers, decimal } from "vuelidate/lib/validators";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
import { Switch as cSwitch } from "@coreui/vue";
import { CoolSelect } from "vue-cool-select";
import datepicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import SeatingRow from "@/components/CustomRowComponents/SeatingRow.vue";
import FilterRow from "@/components/CustomRowComponents/FilterRow.vue";
import StatisticsContainer from "@/components/CustomSubComponents/StatisticsContainer.vue";
import AppointmentContainer from "@/components/CustomSubComponents/AppointmentContainer.vue";
import SeminarTracker from "@/components/CustomSubComponents/SeminarTracker.vue";
import ZipEditor from "@/components/CustomSubComponents/ZipEditor.vue";
import CurrentZipEditor from "@/components/CustomSubComponents/CurrentZipEditor.vue";
import StyledDialogReviewOrder from "@/components/dialogs/StyledDialogReviewOrder.vue";
import StyledDialogConfirmOrder from "@/components/dialogs/StyledDialogConfirmOrder.vue";
import ConflictsModal from "@/components/dialogs/ConflictsModal.vue";
export default {
  name: "SeminarProfile",
  components: {
    StyledDialog,
    cSwitch,
    CoolSelect,
    datepicker,
    SeatingRow,
    FilterRow,
    StatisticsContainer,
    SeminarTracker,
    ZipEditor,
    CurrentZipEditor,
    AppointmentContainer,
    StyledDialogReviewOrder,
    StyledDialogConfirmOrder,
    ConflictsModal
  },
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      zip_seen: false,
      filters_seen: false,
      seating_seen: false,
      aux_seen: false,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      showDismissibleAlert: false,
      StatusType: 0,
      StatusTypeString: "test",
      options: {
        format: "MM/DD/YYYY",
        useCurrent: true,
        // ,
        // minDate: new Date()
        // ,
        // daysOfWeekDisabled: [0, 6]
      },
      myIterator: 0
    };
  },
  methods: {
    componentKey: function(code)
    {
      return code + this.myIterator;
    },
    toggleAux() {
      this.aux_seen = !this.aux_seen;
    },
    toggleSeatings() {
      this.seating_seen = !this.seating_seen;
    },
    toggleFilters() {
      this.filters_seen = !this.filters_seen;
    },
    toggleZips() {
      this.zip_seen = !this.zip_seen;
    },
    async refreshZips() {
      await this.$store
        .dispatch(
          "seminar/RefreshZips",
          this.$store.state.seminar.seminar_edit.SeminarID
        )
        .then((response) => {
          this.$store.state.seminar.seminar_edit.Zips =
            response.data["RefreshZipsResult"];
        });
    },
    async reloadZips() {
      await this.$store
        .dispatch(
          "seminar/ReloadZips",
          this.$store.state.seminar.seminar_edit.TerritoryID
        )
        .then((response) => {
          this.$store.state.seminar.seminar_edit.Zips =
            response.data["ReeloadZipsResult"];
        });
    },
    removeSeating(seating) {
      this.$store
        .dispatch("seminar/DeleteSeating", seating)
        .then(
          (this.$store.state.seminar.seminar_edit.Seatings = this.$store.state.seminar.seminar_edit.Seatings.filter(
            (del) => del.SeatingID !== seating.SeatingID
          ))
        );
    },
    changeSeatingDate() {
      this.zip_seen = false;
      this.aux_seen = false;
    },
    removeFilter(filter) {
      this.$store
        .dispatch("seminar/DeleteFilter", filter)
        .then(
          (this.$store.state.seminar.seminar_edit.Filters = this.$store.state.seminar.seminar_edit.Filters.filter(
            (del) => del.FilterID !== filter.FilterID
          ))
        );
      this.refreshZips();
    },
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    async addSeating() {
      var _s = await this.createFreshObject();
      this.$store.state.seminar.seminar_edit.Seatings.push(
        _s
      );
      this.myIterator++;
      //alert(_s.SeatingID)
    },
    async setSeatingID(seating)
    {
      var _api  = await this.$store
        .dispatch("seminar/AddSeating", seating)
         return _api.data["AddSeatingResult"];
    },
    async createFreshObject() {
      var _t = this.$store.state.seminar.restaurants.find(rest => rest.RestaurantID === -1);
      if (!_t)
      {
        _t = {
          RestaurantID: -1, 
          Name: "(to be determined)"
        }
      }
      
      var _newSeating = 
       {
        SeatingID: -1,
        SeminarID: this.$store.state.seminar.seminar_edit.SeminarID,
        RestaurantID: -1,
        Restaurant: _t,
        CuisineID: -1,
        SeminarTypeID: -1,
        SeminarType: this.$store.state.seminar.seminar_types.find(st => st.SeminarTypeID === -1),
        DateOfSeating: new Date().toLocaleDateString("en-US"),
        Attendee1Count: 0,
        Attendee2Count: 0,
        WaitList1Count: 0,
        WaitList2Count: 0,
        Web1Count: 0,
      }

      _newSeating.SeatingID = await this.setSeatingID(_newSeating);
      
      return _newSeating;



    },
    async addFilter() {
      await this.$store.state.seminar.seminar_edit.Filters.push(
        this.createFreshFilterObject()
      );
      this.refreshZips();
    },

    createFreshFilterObject() {
      return {
        FilterID: -1,
        SeminarID: this.$store.state.seminar.seminar_edit.SeminarID,
        Age: "",
        Income: "",
        Dwelling: "",
        Ethnicity: "",
        Other: "",
      };
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    requestCounts() {
      //this.reviewOrderType = "Count Request";
      this.StatusType = 0;
      this.StatusTypeString = "Request Counts";
      this.$bvModal.show("modal-review");
    },
    submitOrder() {
      //this.reviewOrderType = "Count Request";
      this.StatusType = 2;
      this.StatusTypeString = "Place Order";
      this.$bvModal.show("modal-review");
    },
    confirmCounts() {
      //this.reviewOrderType = "Confirm Order";
      this.StatusType = 1;
      this.$bvModal.show("modal-confirm");
    },
    save() {
      if (this.dirtyFields.length) {
        this.$v.$touch();
        if (this.$v.$error) {
          this.dismiss2CountDown = this.dismiss2Secs;
        } else {
          this.$store
            .dispatch("saveOp/BuildSaveOperation")
            .then(
              this.$store
                .dispatch("saveOp/EmitSave")
                .then(
                  (this.dirtyFields = [])(
                    (this.dismissCountDown = this.dismissSecs)
                  )(this.$store.state.saveOp.DestroySaveOperation)
                )
            );
        }
      }
    },
    addDirtyField: function (event) {
      this.dirtyFields = this.dirtyFields.filter(
        (dirtyField) => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value,
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldWatch: function (field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        (dirtyField) => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue,
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    saveField: function (event) {
      var _operation = {
        SeminarID: this.$store.state.seminar.seminar_edit.SeminarID,
        FieldToSet: event.target.id,
        ValueToSet: event.target.value,
      };

      this.$store.dispatch("seminar/SaveSeminarField", _operation).then();
    },
    addDirtyFieldSwitch: function (event) {
      this.dirtyFields = this.dirtyFields.filter(
        (dirtyField) => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString(),
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    setArtwork1Name(event) {
      // this.$store.state.seminar.seminar_edit.Artwork1.ArtworkName =
      //   event.ArtworkName;
      this.$store.state.seminar.seminar_edit.Artwork1 =
        event;
    },
    setArtwork2Name(event) {
      // this.$store.state.seminar.seminar_edit.Artwork2.ArtworkName =
      //   event.ArtworkName;
        this.$store.state.seminar.seminar_edit.Artwork2 =
        event;
    },
    setTerritoryName(event) {
      // this.$store.state.seminar.seminar_edit.Territory.TerritoryName =
      //   event.TerritoryName;
        this.$store
        .dispatch("territory/loadTerritoryEdit", event.TerritoryID)
        .then(() => {
        this.$store.state.seminar.seminar_edit.Territory =
        this.$store.state.territory.territory_edit
        })
    },
    setVendorName(event) {
      this.$store.state.seminar.seminar_edit.Vendor = event;
    },
    setOwnerName(event) {
      this.$store.state.seminar.seminar_edit.Owner = event;
    },
  },
  computed: {
    ...mapState(["seminar", "territory", "n_user"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },
    ModalStatusText() {
      return this.StatusTypeString;
    },
    zipButtonText() {
      if (this.zip_seen) {
        return "Done";
      } else {
        return "Edit Zip Codes";
      }
    },
  },
  created() {},
  watch: {
    "$store.state.seminar.seminar_edit.SeminarID": function (
      newValue,
      oldValue
    ) {
      if (oldValue === -1) {
        this.addSeating();
        this.addFilter();
      }
    },
    "$store.state.seminar.seminar_edit.TerritoryID": function (newValue) {
      this.addDirtyFieldWatch(
        "TerritoryID",
        this.$store.state.seminar.seminar_edit.TerritoryID
      );
      this.zip_seen = false;
      if (this.$store.state.seminar.seminar_edit.SeminarID > 0) {
        var _event = {
          target: {
            id: "TerritoryID",
            value: this.$store.state.seminar.seminar_edit.TerritoryID,
          },
        };
        this.saveField(_event);
      }
      this.$store.state.seminar.seminar_edit.Territory = this.$store.state.territory.territories.find(t => t.TerritoryID === newValue)
    },
    "$store.state.seminar.seminar_edit.UserProfileID": function () {
      this.addDirtyFieldWatch(
        "UserProfileID",
        this.$store.state.seminar.seminar_edit.UserProfileID
      );
    },
    "$store.state.seminar.seminar_edit.EventTypeID": function () {
      this.addDirtyFieldWatch(
        "EventTypeID",
        this.$store.state.seminar.seminar_edit.EventTypeID
      );
    },
    "$store.state.seminar.seminar_edit.VendorID": function () {
      this.addDirtyFieldWatch(
        "VendorID",
        this.$store.state.seminar.seminar_edit.VendorID
      );
    },
    "$store.state.seminar.seminar_edit.IsSplit": function () {
      this.addDirtyFieldWatch(
        "IsSplit",
        this.$store.state.seminar.seminar_edit.IsSplit
      );
    },
    "$store.state.seminar.seminar_edit.Artwork1ID": function () {
      this.addDirtyFieldWatch(
        "Artwork1ID",
        this.$store.state.seminar.seminar_edit.Artwork1ID
      );
    },
    "$store.state.seminar.seminar_edit.Artwork2ID": function () {
      this.addDirtyFieldWatch(
        "Artwork2ID",
        this.$store.state.seminar.seminar_edit.Artwork2ID
      );
    },
    "$store.state.seminar.seminar_edit.ContractReceived": function () {
      this.addDirtyFieldWatch(
        "ContractReceived",
        this.$store.state.seminar.seminar_edit.ContractReceived
      );
    },
    "$store.state.seminar.seminar_edit.Seatings.length": function (newValue) {
    
    },
  },
  mounted() {
    this.$store.state.saveOp.localUrl = "/Seminar/SaveSeminar/";
    this.$store.state.saveOp.localVariableName = "_s";
    this.$store.state.saveOp.localVariableObject = this.$store.state.seminar.seminar_edit;
    // {
    //   SeminarID: this.$store.state.seminar.seminar_edit.SeminarID,
    //   UserProfileID: this.$store.state.seminar.seminar_edit.UserProfileID,
    //   };
    this.$store.state.saveOp.localFieldToSet = "SeminarID";
    this.$store.state.saveOp.localReturnObject = "SaveSeminarResult";

    this.$store
      .dispatch(
        "territory/loadTerritoryEdit",
        this.$store.state.seminar.seminar_edit.TerritoryID
      )
      .then(() => {
        //this.$router.push({ name: "Territory" });
      });
  },
  validations: {
    seminar: {
      seminar_edit: {
        TerritoryID: {
          required,
          
        },
        Cost1: {
          decimal
        }, 
        Cost2: {
          decimal
        }, 
      },
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
.icon-small {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
